module.exports = __webpack_public_path__ + "static/img/Sam.Lonergan.f62ce8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam.Lonergan.jpg
// module id = p7gN
// module chunks = 0